const getters = {
  cart_show: state => state.shoppping_cart.show,
  cart_qty: state => state.shoppping_cart.qty,
  cart_subtotal: state => parseFloat(state.shoppping_cart.subtotal).toFixed(2),
  cart_goodslist: state => state.shoppping_cart.goodslist,
  cart_chooselist: state => state.shoppping_cart.chooseList,
  cart_productqty: state => state.shoppping_cart.productQty,
  products: state => state.shoppping_cart.products,
  cart_attr_radio: state => state.shoppping_cart.attrRadio,
  cart_goods_addons: state => state.shoppping_cart.radioGoodsAddons, //radioGoodsAddons
  x_sso_token: state => state.shoppping_cart.x_sso_token,
  store_info: state => state.shoppping_cart.storeInfo,

  delivery_current_storeinfo: state => state.delivery.current_storeinfo,
  delivery_current_user: state => state.delivery.current_user,
  delivery_current_address: state => state.delivery.current_address,
  lalamove_list: state => state.delivery.lalamove_list,
  easyparcel_list: state => state.delivery.easyparcel_list,
  teleport_list: state => state.delivery.teleport_list,
  delyva_list: state => state.delivery.delyva_list,

  user_islogin: state => state.user.is_login,
  user_detail: state => state.user.userinfo,
  user_xsso_token: state => state.user.x_sso_token,
}

export default getters